export const isUserUnverified = (userSub: string, userEmailVerified: boolean): boolean =>
  ['auth0', 'google-oauth2'].includes(userSub.split('|')[0]) && !userEmailVerified;
